import moment from "moment";

export function dateCannotBeInFuture(value) {
  if (moment(value).isValid() && moment(value).isAfter(moment())) {
    return "Please select a date that is not in the future";
  } else {
    return "";
  }
}
